import React from 'react';
import styled from '@emotion/styled';
import { MoreHorizontal } from '../../../../components/Icons/MoreHorizontal';
import { useAppSelector } from '../../../../redux/store';

const SideCard = () => {
  const { authData } = useAppSelector((state) => state.auth);

  return (
    <Container>
      <More>
        <MoreHorizontal />
      </More>
      <Face>
        <img src="/static/img/avatar-face.png" alt="avatar" />
      </Face>
      <Tag>{authData?.institutionName}</Tag>
      <Name>
        Primary Health Care | {authData?.localGovernment}, {authData?.state}
      </Name>
      <Address>{authData?.street}, {authData?.localGovernment}, {authData?.state}</Address>
    </Container>
  );
};

export default SideCard;

const Container = styled.div`
  width: 100%;
  max-width: 270px;
  height: 200px;
  margin-top: 40px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.palette.backgroundColor};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.7rem;
`;

const More = styled.div`
  width: fit-content;
  position: absolute;
  right: 10px;
  top: 10px;
  color: ${({ theme }) => theme.palette.greyGrey3};
`;

const Face = styled.div`
  width: 62px;
  height: 62px;
  background-color: white;
  border-radius: 50%;
`;

const Tag = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -1px;
  color: ${({ theme }) => theme.palette.mainBlue};
`;

const Name = styled.p`
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -1px;
  color: ${({ theme }) => theme.palette.greyGrey2};
`;

const Address = styled.p`
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -1px;
  color: ${({ theme }) => theme.palette.blackBlack3};
`;
